
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleRegionList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/region/list${queryString}`
    );
}

export async function consoleRegionGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/region/${item_id}/show`
    );
}

export async function consoleRegionCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/region/create`,
        payload
    );
}

export async function consoleRegionPatch(
    item_id: string,
    payload: Partial<any>
) {
    return await clientAxios.patch(
        `admin/console/region/${item_id}/patch`,
        { payload }
    );
}

export async function consoleRegionDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/region/${item_id}/delete`,
    );
}
